// src/utils/lineText.js — GENERATED from functions/utils/lineText.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildWebLineText.js   (linetext-4d8b2e61)
// src/utils/lineText.test.js fails if this file is not exactly what the generator writes.
// What this does and why: see the header of functions/utils/lineText.js. Screens use lineTextBlocks
// (through src/components/documents/LineDescription.js), never lineTextHtml.

/* eslint-disable */

// LINETEXT-BODY-START
var LINE_TEXT_MAX = 4000;        // QuickBooks' own limit on a line description; the editors cap here
var LINE_TEXT_INDENT_CAP = 16;   // more leading spaces than this indent no further
var LINE_TEXT_TAB_SPACES = 4;
var LINE_TEXT_EM_PER_SPACE = 0.5;
// A bullet is TWO COLUMNS: the "•" in a fixed-width column, the text in the next. Every line of the text,
// wrapped or not, starts at the text column's left edge — exact by construction, in every PDF, email client
// and screen (Marcus, 2026-10-28: the old negative-text-indent hang sat a few px right in the PDF and was
// dropped by Gmail).
var LINE_TEXT_BULLET_EM = 0.8;   // the bullet column, in em of the description's own font size
var LINE_TEXT_DEFAULT_FONT_PX = 13;
var LINE_TEXT_BULLET = /^[-*][ \t]+(\S[\s\S]*)$/;

function lineTextNormalize(text) {
  if (text === null || text === undefined) return '';
  return String(text).replace(/\r\n?/g, '\n');
}

// True when the text shows exactly as one plain line: nothing for this file to do.
function lineTextIsPlain(text) {
  var s = lineTextNormalize(text);
  return s.indexOf('\n') < 0 && !/^[ \t]/.test(s) && !LINE_TEXT_BULLET.test(s);
}

// The description as blocks: { kind: 'text' | 'bullet' | 'blank', indent: spaces, text }.
// Blank lines at the start and end are dropped; a run of blank lines becomes one.
function lineTextBlocks(text) {
  var lines = lineTextNormalize(text).split('\n');
  var out = [];
  for (var i = 0; i < lines.length; i++) {
    var raw = lines[i].replace(/[ \t]+$/, '');
    var lead = /^[ \t]*/.exec(raw)[0];
    var rest = raw.slice(lead.length);
    if (!rest) {
      if (out.length && out[out.length - 1].kind !== 'blank') out.push({ kind: 'blank', indent: 0, text: '' });
      continue;
    }
    var spaces = 0;
    for (var j = 0; j < lead.length; j++) spaces += lead.charAt(j) === '\t' ? LINE_TEXT_TAB_SPACES : 1;
    var indent = Math.min(spaces, LINE_TEXT_INDENT_CAP);
    var m = LINE_TEXT_BULLET.exec(rest);
    out.push(m ? { kind: 'bullet', indent: indent, text: m[1] } : { kind: 'text', indent: indent, text: rest });
  }
  while (out.length && out[out.length - 1].kind === 'blank') out.pop();
  return out;
}

// How far a block starts from the left (em): its leading spaces. A bullet's "•" sits here; its text one
// bullet column further. Shared by the HTML below and the screens.
function lineTextIndentEm(block) {
  return block.indent * LINE_TEXT_EM_PER_SPACE;
}

// The description as HTML for the server's PDFs and emails. escapeHtml is passed in (this body has no
// imports). opts.fontPx / opts.color: the description's own size and colour — written onto a bullet's cells
// because a table does not inherit them in some email clients (Outlook) or in a page without a doctype (the PDF).
// A text line is a block-level <span> with pre-wrap (keeps spaces inside a line); a blank line is one empty
// line; a bullet is a one-row table: [indent + "•" | text]. Its cells set border:0 and content-box sizing
// themselves, so a page's own table rules (the PDF's `.items-table td` border, `* { box-sizing: border-box }`)
// can't reach them. A plain one-line description returns
// escapeHtml(text) unchanged.
function lineTextHtml(text, escapeHtml, opts) {
  if (lineTextIsPlain(text)) return escapeHtml(text === null || text === undefined ? '' : text);
  var fontPx = opts && opts.fontPx > 0 ? opts.fontPx : LINE_TEXT_DEFAULT_FONT_PX;
  var font = 'font-size:' + fontPx + 'px;' + (opts && opts.color ? 'color:' + opts.color + ';' : '');
  var bulletPx = Math.round(fontPx * LINE_TEXT_BULLET_EM);
  var blocks = lineTextBlocks(text);
  var html = '';
  for (var i = 0; i < blocks.length; i++) {
    var b = blocks[i];
    if (b.kind === 'blank') { html += '<span style="display:block;">&nbsp;</span>'; continue; }
    var em = lineTextIndentEm(b);
    if (b.kind === 'text') {
      html += '<span style="display:block;white-space:pre-wrap;' + (em ? 'padding-left:' + em + 'em;' : '') + '">' + escapeHtml(b.text) + '</span>';
      continue;
    }
    var indentPx = Math.round(fontPx * em);
    html += '<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;"><tr>'
      + '<td width="' + (indentPx + bulletPx) + '" style="box-sizing:content-box;border:0;width:' + bulletPx + 'px;min-width:' + bulletPx + 'px;padding:0 0 0 ' + indentPx + 'px;vertical-align:top;' + font + '">&bull;</td>'
      + '<td style="border:0;padding:0;vertical-align:top;white-space:pre-wrap;' + font + '">' + escapeHtml(b.text) + '</td>'
      + '</tr></table>';
  }
  return html;
}
// LINETEXT-BODY-END

export { LINE_TEXT_MAX, LINE_TEXT_BULLET_EM, lineTextNormalize, lineTextIsPlain, lineTextBlocks, lineTextIndentEm, lineTextHtml };
